import Component from 'vue-class-component';
import Vue from 'vue';
import {Subject} from 'rxjs';
import Vue2TouchEvents from 'vue2-touch-events';

require('@/components/components');
require('@/filters/filters');
Vue.component('intersect', require('vue-intersect').default);
Vue.use(require('vue-resize-observer'));
Vue.use(require('vue-observe-visibility'));
Vue.use(Vue2TouchEvents)

@Component({})
export default class PageBase extends Vue {
    public isPageReady: boolean = false;
    public whenPageReady: Subject<void> = new Subject();

    constructor(options: any) {
        super(options);
    }

    public mounted(): void {
        this.isPageReady = true;
        Vue.nextTick(() => {
            this.whenPageReady.next();
        });
    }
}
